export default "__VITE_ASSET__91cdd6bf__"